import React, { useContext } from 'react';
import { OnboardingStepTitle } from '@vyce/core/src/components/OnboardingStepTitle';
import { CompanyFilter } from '@vyce/core/src/components/CompanyFilter';
import { PayModuleContext } from '../../../contexts/payrollModule';
import { Box } from '@material-ui/core';
import { Company } from '@vyce/core/src/types';

interface Props {
  onCompanyChange: Function;
  companies?: Company[];
}

export const CompanyStep: React.FC<Props> = ({ onCompanyChange, companies }) => {
  const { companies: companiesFromContext } = useContext(PayModuleContext);
  const companiesToUse = companies || companiesFromContext;

  return (
    <>
      <OnboardingStepTitle text="Please choose a company" />

      <Box marginTop={2}>
        <CompanyFilter companies={companiesToUse || []} onCompanyChange={onCompanyChange} />
      </Box>
    </>
  );
};
